import React, { useState } from 'react'
import {
  makeStyles,
  Typography,
  useMediaQuery,
  Tab,
  Tabs,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Fade } from 'react-awesome-reveal'
import Imme_1 from '../../../assets/Home/Images/Imme_1.2.png'
import Imme_2 from '../../../assets/Home/Images/Imme_2.2.png'
import Imme_3 from '../../../assets/Home/Images/Imme_3.2.png'
import FadingText from '../../../components/FadingText'
import Carousel from '../../../components/Carousel'
import LinkButton from '../../../components/LinkButton'
import routes from '../../../routes'

const useStyles = makeStyles((theme) => ({
  /**
   * || Reusable Components
   * ======================================= */
  sectionTitle: {
    marginBottom: 15,
    // maxWidth: 280,
    color: 'white',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 420,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 525,
    },
  },
  sectionDescription: {
    maxWidth: 450,

    color: 'white',

    textAlign: 'center',

    [theme.breakpoints.up('tablet')]: {
      maxWidth: 500,
    },

    [theme.breakpoints.up('desktop')]: {
      maxWidth: 700,
    },
  },
  sectionOverline: {
    color: 'rgba(47, 164, 59, 1)',
  },

  /**
   * || Introducing Imme Section
   * ======================================= */
  immeSection: {
    maxWidth: theme.custom.maxWidth,
    margin: 'auto',

    overflow: 'hidden',
    paddingBottom: 0,
    height: 935,

    background:
      'linear-gradient(179.63deg, #192B3E 61.31%, rgba(0, 0, 0, 0.28) 206.5%)',
    // backgroundColor: '#F0F4F8',

    // [theme.breakpoints.up('tablet')]: {
    //   height: 500,
    //   paddingBottom: 0,
    //   marginTop: 150,
    // },

    [theme.breakpoints.up('desktop')]: {
      height: 505,
      paddingBottom: 0,
      marginTop: 150,
    },
  },
  immeTextContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',

    // paddingTop: 50,

    textAlign: 'center',

    // [theme.breakpoints.up('tablet')]: {
    //   alignItems: 'flex-start',
    // },

    [theme.breakpoints.up('desktop')]: {
      alignItems: 'flex-start',

      marginBottom: 30,
    },
  },
  immeText: {
    [theme.breakpoints.up('desktop')]: {
      textAlign: 'left',
    },
  },
  featureTabLabel: {
    fontFamily: 'Poppins,sans-serif',
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'none',
    color: 'white',

    paddingLeft: 20,
    paddingRight: 20,

    [theme.breakpoints.up('tablet')]: {
      // background: 'orange',
      fontSize: '0.9vw',
    },

    [theme.breakpoints.up('desktop')]: {
      fontSize: 16,
    },
  },
  carouselImg: {
    width: '260px',
    height: '531px',
    margin: '8px auto 8px auto',

    // boxShadow: '0px 0px 14px rgba(0, 0, 0, 0.25)',
    // backgroundColor: '#f4f4f4',
    // borderRadius: 20,

    [theme.breakpoints.up('tablet')]: {
      width: '230px',
      height: '490px',
      marginTop: 45,
      // margin: '8px auto 8px auto',
    },

    [theme.breakpoints.up('desktop')]: {
      margin: '0px 0px 0px 80px',
      padding: 5,
      width: '260px',
      height: '531px',
    },
  },
  immeColumnLeft: {
    display: 'flex',
    flexDirection: 'column',
    // minWidth: 600,
    maxWidth: 1050,
    // background: 'pink',
    height: '100%',
    justifyItems: 'flex-start',

    // [theme.breakpoints.up('tablet')]: {
    //   minWidth: 0,
    // },

    [theme.breakpoints.up('desktop')]: {
      // minWidth: 600,
    },
  },
  immeFlexContainer: {
    display: 'flex',
    height: '100%',
    // margin: '0px 70px',
    padding: 30,
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.up('tablet')]: {
      padding: '50px 70px',
    },

    [theme.breakpoints.up('desktop')]: {
      margin: 'auto',
      // maxWidth: 1100,
    },

    [theme.breakpoints.up('desktopXL')]: {
      margin: 'auto',
      // maxWidth: 1100,
    },
  },
  tabPanel: {
    maxWidth: '70%',
    marginTop: 25,

    color: 'white',
  },

  // BOLD TEXT
  bold: {
    fontWeight: 900,
    color: 'white',
  },
  youtubeVideo: {
    width: '100%',
    height: '80%',
    [theme.breakpoints.up('desktop')]: {
      width: '95%',
      height: '95%',
    },
    [theme.breakpoints.up('desktopXL')]: {
      width: '75%',
      height: '95%',
    },
  },
  videoContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // [theme.breakpoints.up('tablet')]: {
    //   paddingLeft: '20px',
    // },

    [theme.breakpoints.up('desktop')]: {
      width: '70%',
      height: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  mobileContainer: {
    display: 'flex',
    alignItems: 'space-between',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '100%',
    paddingTop: 50,
    paddingBottom: 0,
    paddingLeft: 30,
    paddingRight: 30,

    textAlign: 'center',
  },
}))
export default function ImmeSection() {
  const classes = useStyles()
  const theme = useTheme()
  const isDesktopUp = useMediaQuery(theme.breakpoints.up('desktop'))
  const isTabletUp = useMediaQuery(theme.breakpoints.up('tablet'))
  const [carouselIndex, setCarouselIndex] = useState(0)

  const phrases = [
    'Customers',
    'Gamers',
    'Users',
    'Patients',
    'Students',
    'Partners',
    'Traders',
    'Family',
    'Employees',
    'Community',
    'Stakeholders',
    'Creators',
    'Teammates',
    'Borrowers',
    'Clients',
    'Buyers',
    'Applicants',
    'Associates',
    'Candidates',
    'People',
    'Viewers',
    'Readers',
    'Consumers',
    'Donors',
    'Supporters',
  ]

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      const temp = array[i]
      // eslint-disable-next-line no-param-reassign
      array[i] = array[j]
      // eslint-disable-next-line no-param-reassign
      array[j] = temp
    }
  }

  const immeFeatures = [
    {
      title: 'People-First By Design',
      description:
        'imme® is designed to be truly people-first. We make authentication simple and convenient, and improve personal security by designing our processes under Zero-Knowledge protocols.',
      image: Imme_1,
      imageAlt: 'Imme app landing screen',
    },
    {
      title: 'Big-Picture Thinking',
      description:
        "imme® is about giving users control of their digital lives. It's a lifestyle brand that promises to do things differently by offering creative solutions to problems that no one else is adequately addressing.",
      image: Imme_2,
      imageAlt: 'Imme app home screen with id management and digital score',
    },
    {
      title: 'Proactive Solutions',
      description:
        'Digital Identity management is the future. imme® builds a lifelong, reusable, self-sovereign digital identity that empowers users to unlock the potential of the digital marketplace while staying safe, secure, and private.',
      image: Imme_3,
      imageAlt: 'Imme app document upload & verification screen',
    },
  ]
  return (
    <section className={classes.immeSection}>
      {isDesktopUp ? (
        <div className={classes.immeFlexContainer}>
          <div className={classes.immeColumnLeft}>
            <Fade triggerOnce>
              <div className={classes.immeTextContainer}>
                <Typography
                  variant='h1'
                  className={`${classes.sectionTitle} ${classes.immeText}`}
                  style={{
                    marginTop: 5,
                    marginBottom: 0,
                    whiteSpace: 'nowrap',
                  }}
                >
                  It Starts With Your{' '}
                </Typography>
                <Typography
                  variant='h1'
                  className={`${classes.sectionTitle} ${classes.immeText}`}
                  style={{
                    marginTop: 5,
                    marginBottom: 45,
                    whiteSpace: 'nowrap',
                  }}
                >
                  <FadingText
                    phrases={phrases}
                    onReachArrayEnd={() => shuffleArray(phrases)}
                  />
                </Typography>
                <Typography
                  variant='h4'
                  className={`${classes.sectionTitle} ${classes.immeText}`}
                  style={{ marginTop: 5, marginBottom: 15 }}
                >
                  Improved Connectivity & Security
                </Typography>
                <Typography
                  variant='body1'
                  className={`${classes.sectionDescription} ${classes.immeText}`}
                  style={{ marginTop: 5, marginBottom: 25 }}
                >
                  Legacy connectivity platforms create user experiences filled
                  with friction. Our IDK transforms how digital access happens
                  through our proprietary AI software and Zero-Knowledge
                  protocols.
                </Typography>
                <Typography
                  variant='h4'
                  className={`${classes.sectionTitle} ${classes.immeText}`}
                  style={{ marginTop: 5, marginBottom: 15 }}
                >
                  Empower your users to connect with you in ways that will keep
                  them safe, secure, and in the fast lane.
                </Typography>
                <Typography
                  variant='body1'
                  className={`${classes.sectionDescription} ${classes.immeText}`}
                >
                  Connect new and existing users to your business with enhanced
                  privacy, reinforced security, accelerated onboarding, and
                  effortless authentication, removing major barriers between
                  your business and your customers.
                </Typography>
              </div>
            </Fade>
          </div>
          {/* <Fade triggerOnce delay={600}> */}
          <div className={`${classes.videoContainer}`}>
            <iframe
              className={`${classes.youtubeVideo}`}
              src='https://www.youtube.com/embed/-k5W4jZtGaE?si=1_hueW8xPaQWxJlp'
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              frameBorder='0'
              // referrerpolicy='strict-origin-when-cross-origin'
              allowfullscreen
            />
          </div>
          {/* </Fade> */}
        </div>
      ) : (
        <div className={classes.mobileContainer}>
          <Fade triggerOnce>
            <div className={classes.immeTextContainer}>
              <Typography
                variant='h1'
                className={`${classes.sectionTitle} ${classes.immeText}`}
                style={{ marginTop: 5, marginBottom: 0 }}
              >
                It Starts With Your{' '}
              </Typography>
              <Typography
                variant='h1'
                className={`${classes.sectionTitle} ${classes.immeText}`}
                style={{
                  marginBottom: 45,
                  whiteSpace: 'nowrap',
                }}
              >
                <FadingText
                  phrases={phrases}
                  onReachArrayEnd={() => shuffleArray(phrases)}
                />
              </Typography>
              <Typography
                variant='h4'
                className={`${classes.sectionTitle} ${classes.immeText}`}
                style={{ marginTop: 5, marginBottom: 15 }}
              >
                Improved Connectivity & Security
              </Typography>
              <Typography
                variant='body1'
                className={`${classes.sectionDescription} ${classes.immeText}`}
                style={{ marginTop: 5, marginBottom: 25 }}
              >
                Legacy connectivity platforms create user experiences filled
                with friction. Our IDK transforms how digital access happens
                through our proprietary AI software and Zero-Knowledge
                protocols.
              </Typography>
              <Typography
                variant='h4'
                className={`${classes.sectionTitle} ${classes.immeText}`}
                style={{ marginTop: 5, marginBottom: 15 }}
              >
                Empower your users to connect with you in ways that will keep
                them safe, secure, and in the fast lane.
              </Typography>
              <Typography
                variant='body1'
                className={`${classes.sectionDescription} ${classes.immeText}`}
              >
                Connect new and existing users to your business with enhanced
                privacy, reinforced security, accelerated onboarding, and
                effortless authentication, removing major barriers between your
                business and your customers.
              </Typography>
            </div>
          </Fade>

          <div className={`${classes.videoContainer}`}>
            <iframe
              className={`${classes.youtubeVideo}`}
              src='https://www.youtube.com/embed/-k5W4jZtGaE?si=1_hueW8xPaQWxJlp'
              title='YouTube video player'
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
              frameBorder='0'
              // referrerpolicy='strict-origin-when-cross-origin'
              allowfullscreen
            />
          </div>
        </div>
      )}
    </section>
  )
}
